// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    const body = document.querySelector('body');

    window.addEventListener('scroll', () => {
        stickyNav();
    });

    window.addEventListener('resize', () => {
        stickyNav();
    });

    // Toggle sticky class
    const stickyNav = () => {
        if (window.scrollY > 50) {
            body.classList.add('sticky_nav');
        } else {
            body.classList.remove('sticky_nav');
        }
    }

    if (window.screen.width <= 1024) {
        const subMenu = document.querySelectorAll(".dropdown-toggle");

        subMenu.forEach(subMenuItem => {
            subMenuItem.addEventListener('click', () => {
                subMenuItem.classList.toggle("dropdown-is-open");
            });
        });
    }
});

document.addEventListener('scroll', function() {
    let scrollHeight = window.scrollY;
    
    let targetElement = document.querySelector('.scroll');
    
    if (targetElement) {
        if (scrollHeight > window.innerHeight) {
            targetElement.classList.add('show');
        } else {
            targetElement.classList.remove('show');
        }
    }
});
